import { cva } from 'class-variance-authority';

export const wrapperClasses = 'flex cursor-pointer items-center select-none';

export const boxClasses = 'relative';

export const circleBgClasses = cva(['box block h-5 w-9 rounded-full relative transition'], {
  variants: {
    checked: {
      true: 'bg-[#349269]',
      false: 'bg-[#E6E6E6]'
    },
    disabled: {
      true: 'opacity-50',
      false: 'opacity-100'
    }
  },
  defaultVariants: {
    checked: false,
    disabled: false
  }
});

export const circleIconClasses = cva(['absolute right-1 top-1 transition z-20']);

export const circleClasses = cva(
  [
    'top-0-5 absolute flex h-4 w-4 z-10 items-center justify-center rounded-full bg-white transition'
  ],
  {
    variants: {
      checked: {
        true: 'right-0-5',
        false: 'left-0-5'
      },
      disabled: {
        true: 'opacity-50',
        false: 'opacity-100'
      }
    },
    defaultVariants: {
      checked: false,
      disabled: false
    }
  }
);
